import { AccordionDetails, AccordionDetailsProps } from '@mui/material'
import { styled } from '@mui/system'

export const CustomAccordionDetails = styled((props: AccordionDetailsProps) => (
  <AccordionDetails {...props} />
))(() => ({
  padding: 0
}))
